export default "__VITE_ASSET__Cn2CkA_s__"